import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { from, of } from 'rxjs';
import { catchError, map, mergeMap, switchMap, take } from 'rxjs/operators';

import { select, Store } from '@ngrx/store';
import { selectRouteState } from '@state/route';

import { TripService } from '@services';
import * as TripActions from './trip.actions';

@Injectable()
export class TripEffects {
  constructor(
    private store: Store,
    private actions$: Actions,
    private tripService: TripService
  ) {}

  fetchTrips$ = createEffect(() =>
    this.actions$.pipe(
      ofType(TripActions.fetchTrips),
      switchMap(() =>
        from(this.tripService.getPage()).pipe(
          map((trips) => TripActions.fetchTripsSuccess({ trips })),
          catchError((error) => of(TripActions.fetchTripsFailed({ error })))
        )
      )
    )
  );

  fetchTripById$ = createEffect(() =>
    this.actions$.pipe(
      ofType(TripActions.fetchTripById),
      switchMap(({ tripId }) =>
        from(this.tripService.getById(tripId)).pipe(
          map((trip) => TripActions.fetchTripByIdSuccess({ trip })),
          catchError((error) => of(TripActions.fetchTripByIdFailed({ error })))
        )
      )
    )
  );

  fetchCurrentTrip$ = createEffect(() =>
    this.actions$.pipe(
      ofType(TripActions.fetchCurrentTrip),
      mergeMap(() => this.store.pipe(select(selectRouteState), take(1))),
      switchMap((route) => {
        const tripId = route.params['tripId'];
        return of(TripActions.fetchTripById({ tripId }));
      })
    )
  );
}
